import { Component, computed, input, output } from '@angular/core';

export const BUTTON_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TEXT: 'text',
  ICON: 'icon'
} as const;

export type ButtonVariant = typeof BUTTON_VARIANT[keyof typeof BUTTON_VARIANT];

@Component({
  selector: 'app-button',
  standalone: true,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  label = input<string>('');
  disabled = input<boolean>(false);
  type = input<'button' | 'submit'>('button');
  variant = input<ButtonVariant>('primary');
  fullWidth = input<boolean>(false);
  circle = input<boolean>(false);
  bordered = input<boolean>(false);
  ariaLabel = input<string>('');

  buttonClass = computed(() => {
    let cls = `btn btn--${this.variant()}`;
    if (this.fullWidth()) {
      cls += ' btn--full-width';
    }
    if (this.circle()) {
      cls += ' btn--circle';
    }
    if (this.bordered()) {
      cls += ' btn--bordered';
    }
    return cls;
  });

  clicked = output<void>();

  onClick(): void {
    if (!this.disabled()) {
      this.clicked.emit();
    }
  }
}
